(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sua-categories"] && !Shopify.designMode) return;
  try {
    function initSuaCategories(){
 const source=document.getElementById('SuaCategoryTemplate');if(!source)return;
 let serial=0;const bound=new WeakSet();
 function bind(){document.querySelectorAll('#SiteNav a,#NavDrawer a').forEach(a=>{
  const title=(a.getAttribute('aria-label')||a.textContent).trim().toUpperCase();
  if(title!=='CATEGORIES'||bound.has(a))return;bound.add(a);
  a.dataset.suaCategories='true';a.classList.add('sua-category-trigger');
  const host=a.parentElement;host.classList.add('sua-category-host');host.querySelectorAll(':scope > .sua-category-panel').forEach(p=>p.remove());
  const panel=source.content.firstElementChild.cloneNode(true);panel.id='SuaCategories-'+(++serial);host.appendChild(panel);
  a.setAttribute('aria-controls',panel.id);a.setAttribute('aria-expanded','false');a.setAttribute('aria-haspopup','true');
  const close=()=>{panel.hidden=true;a.setAttribute('aria-expanded','false');};
  const toggle=e=>{e.preventDefault();e.stopImmediatePropagation();const opened=a.getAttribute('aria-expanded')==='true';panel.hidden=opened;a.setAttribute('aria-expanded',String(!opened));};
  let touchStart=null,lastTouchToggle=0;
  host.addEventListener('touchstart',e=>{const t=e.touches[0];touchStart=t?{x:t.clientX,y:t.clientY}:null;},{capture:true,passive:true});
  host.addEventListener('touchend',e=>{
   if(panel.contains(e.target)){e.stopImmediatePropagation();return;}
   if(!a.contains(e.target))return;
   e.stopImmediatePropagation();const t=e.changedTouches[0];
   if(!t||!touchStart||Math.abs(t.clientX-touchStart.x)>10||Math.abs(t.clientY-touchStart.y)>10)return;
   lastTouchToggle=Date.now();toggle(e);
  },{capture:true,passive:false});
  host.addEventListener('click',e=>{if(panel.contains(e.target))e.stopPropagation();},true);
  a.addEventListener('click',e=>{if(Date.now()-lastTouchToggle<700){e.preventDefault();e.stopImmediatePropagation();return;}toggle(e);},true);
  a.addEventListener('keydown',e=>{if(e.key===' '){toggle(e);}else if(e.key==='ArrowDown'){e.preventDefault();panel.hidden=false;a.setAttribute('aria-expanded','true');panel.querySelector('summary,a')?.focus();}});
  host.addEventListener('keydown',e=>{if(e.key==='Escape'){close();a.focus();}});
  document.addEventListener('click',e=>{if(!host.contains(e.target))close();});
 });}
 document.addEventListener('click',e=>{
  const button=e.target.closest('[data-sua-open-categories]');if(!button)return;
  bind();
  const desktop=Array.from(document.querySelectorAll('#SiteNav .sua-category-trigger')).find(a=>a.getClientRects().length&&getComputedStyle(a).visibility!=='hidden');
  const trigger=desktop||document.querySelector('#NavDrawer .sua-category-trigger');
  if(!trigger)return;
  const panel=document.getElementById(trigger.getAttribute('aria-controls'));if(!panel)return;
  if(!desktop&&!(window.theme&&window.theme.NavDrawer))return;
  e.preventDefault();e.stopImmediatePropagation();
  if(!desktop)window.theme.NavDrawer.open();
  panel.hidden=false;trigger.setAttribute('aria-expanded','true');
  if(desktop)trigger.scrollIntoView({block:'center',behavior:'auto'});
  requestAnimationFrame(()=>{trigger.focus({preventScroll:true});if(!desktop)trigger.scrollIntoView({block:'nearest'});});
 },true);
 bind();document.querySelectorAll('#SiteNav,#NavDrawer').forEach(root=>new MutationObserver(bind).observe(root,{childList:true,subtree:true}));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSuaCategories);else initSuaCategories();
  } catch(e) { console.error(e); }
})();

})();
